import CardsPage from '../Components/Sections/CardsPage';
import {Helmet} from '@dr.pogodin/react-helmet';

const SlotsPage = () => {
    return (
        <>
            <Helmet>
                <title>Slots Portfolio - Lesia K Slot 2D Art Development</title>
                <link rel="canonical" href={`https://lesia-k.com/slots`}/>
                <meta name="description"
                      content="Explore our extensive portfolio of 2D art for slot games. Discover unique designs and high-quality visuals created by Lesia K for various slot game projects."/>
                <meta name="keywords" content="Lesia K, slots portfolio, 2D art showcase, slot game designs, Lesia K portfolio, game art examples"/>
                <meta property="og:title" content="Slots Portfolio - Lesia K Slot 2D Art Development"/>
                <meta property="og:description"
                      content="Explore our extensive portfolio of 2D art for slot games. Discover unique designs and high-quality visuals created by Lesia K for various slot game projects."/>
                <meta property="og:url" content="https://lesia-k.com/slots"/>
                <meta name="twitter:title" content="Slots Portfolio - Lesia K Slot 2D Art Development"/>
                <meta name="twitter:description"
                      content="Explore our extensive portfolio of 2D art for slot games. Discover unique designs and high-quality visuals created by Lesia K for various slot game projects."/>
            </Helmet>
            <div className="pb-24">
                <CardsPage/>
            </div>
        </>
    )
}

export default SlotsPage;
